module.exports = __webpack_public_path__ + "img/1.ce51df08.jpeg";